import { FunctionComponent } from "react";

import {
	usePreviewZohoFieldMappingsMutation,
	useTestZohoSyncMutation,
} from "@/pages/Private/redux/zoho/zoho.api";

import { ZohoEntityType, ZohoField, ZohoSourceField } from "../schema/zoho";
import {
	buildMappingPreviewLabels,
	buildZohoPreviewOutcome,
	buildZohoTestSyncOutcome,
	MappingPreviewModal,
} from "./fieldMapping";
import { AiConfigProspectOption } from "./fieldMapping/aiConfig.types";

type Ts = (key: string, options?: Record<string, unknown>) => string;

interface ZohoMappingPreviewModalProps {
	isOpen: boolean;
	entityType: ZohoEntityType;
	sourceFields: ZohoSourceField[];
	zohoFields: ZohoField[];
	ts: Ts;
	onClose: () => void;
	onSearchProspects: (query: string) => Promise<AiConfigProspectOption[]>;
	onCancelSearchProspects?: () => void;
}

/**
 * Zoho binding for the generic MappingPreviewModal: dry-run preview (with
 * metadata validation warnings) plus the real single-lead test sync.
 */
export const ZohoMappingPreviewModal: FunctionComponent<ZohoMappingPreviewModalProps> = ({
	isOpen,
	entityType,
	sourceFields,
	zohoFields,
	ts,
	onClose,
	onSearchProspects,
	onCancelSearchProspects,
}) => {
	const [previewMappings] = usePreviewZohoFieldMappingsMutation();
	const [testSync] = useTestZohoSyncMutation();

	return (
		<MappingPreviewModal
			isOpen={isOpen}
			labels={buildMappingPreviewLabels(ts, entityType)}
			onCancelSearchProspects={onCancelSearchProspects}
			onClose={onClose}
			onRunPreview={async (prospectId) =>
				buildZohoPreviewOutcome(
					await previewMappings({ prospectId, entityType }).unwrap(),
					sourceFields,
					zohoFields,
					ts
				)
			}
			onSearchProspects={onSearchProspects}
			onTestSync={async (prospectId) =>
				buildZohoTestSyncOutcome(await testSync({ prospectId, entityType }).unwrap(), ts)
			}
		/>
	);
};
